import type {
  Action,
  SagaCallbacks,
} from '../types';

import * as actionTypes from './actionTypes';

export const requestFetchClientNotes = ({
  clientId,
  callbacks,
}: {
  clientId: number
  callbacks?: SagaCallbacks
}): Action => ({
  type: actionTypes.REQUEST_FETCH_CLIENT_NOTES,
  clientId,
  callbacks,
});

export const requestCreateClientNotes = ({
  clientId,
  description,
  callbacks,
}: {
  clientId: number
  description: string
  callbacks?: SagaCallbacks
}): Action => ({
  type: actionTypes.REQUEST_CREATE_CLIENT_NOTES,
  clientId,
  description,
  callbacks,
});

export const requestUpdateClientNotes = ({
  id,
  description,
  callbacks,
}: {
  id: number
  description: string
  callbacks?: SagaCallbacks
}): Action => ({
  type: actionTypes.REQUEST_UPDATE_CLIENT_NOTES,
  id,
  description,
  callbacks,
});

export const requestDeleteClientNotes = ({
  id,
  callbacks,
}: {
  id: number
  callbacks?: SagaCallbacks
}): Action => ({
  type: actionTypes.REQUEST_DELETE_CLIENT_NOTES,
  id,
  callbacks,
});
